import { createContext, useContext } from 'react';
export const FieldInitialDataContext = /*#__PURE__*/createContext(undefined);
export const useFieldInitialData = fieldType => {
  const context = useContext(FieldInitialDataContext);
  if (context) {
    return context[fieldType];
  }
  return null;
};
//# sourceMappingURL=field-initial-data-context.js.map